import React from 'react';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import BillFormContainer from './BillFormContainer';

const BillFormScene = (props) => (
  <>
    <Breadcrumb
      crumbs={[
        ...(props.location.state && props.location.state.from
          ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
          : []),
        {
          text: props.params.billId ? 'Update Bill' : 'Create Bill',
        },
      ]}
    />
    <BillFormContainer billId={props.params.billId} />
  </>
);

export default BillFormScene;
